import React, { useState, useEffect } from 'react';
import { useTower } from '../contexts/TowerContext';
import { useUser } from '../contexts/UserContext';

const TowerSelector = () => {
  const { selectedTower, setSelectedTower } = useTower();
  const [towers, setTowers] = useState([]);
  const [isFetched, setIsFetched] = useState(false);
  const { user } = useUser();
  
  // Function to fetch towers
  const handleFetchTowers = async () => {
    if (!isFetched && user) {
      try {
        const apiUrl = process.env.REACT_APP_FORECAST_API_URL;
        const response = await fetch(`${apiUrl}/towers`, {
            method: "POST", // Use POST for sending data in the body
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ user }), // Send the user variable in JSON format
          });

        const data = await response.json();
        setTowers(data);
        if(data.length > 0){
          setSelectedTower(data[0]);
        }
        // const targetNames = ["Small WTG", "Large WTG"];
        // const filteredData = data.filter(tower => targetNames.includes(tower.name));
        // setTowers(filteredData);
        setIsFetched(true); // Indicate that data has been fetched
      } catch (error) {
        console.error('Failed to fetch towers:', error);
      }
    }
  };

  useEffect(() => {
    setIsFetched(false);
    setTowers([]);
    setSelectedTower(null);
  }, [user]);

  useEffect(() => {
    if (!isFetched) {
      handleFetchTowers();
    }
  }, [user, isFetched]);

  return (
    <div>
      Selected Tower: <select
        value={selectedTower?.name}
        onChange={e => {
          const tower = towers.find(t => t.name === e.target.value);
          setSelectedTower(tower);
        }}
        onFocus={handleFetchTowers} // Also fetch towers when focused, if not already fetched
      >
        {towers.map(tower => (
          <option key={tower.name} value={tower.name}>
            {tower.name} - {tower.newestTimestamp}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TowerSelector;
